module.exports = __webpack_public_path__ + "static/media/PrincessUnlimitedSamples.e7d98460.jpg";